import { useState } from 'react';
import { DialogUI } from '../Interface';
import { useFormikContext } from 'formik';
import { Box, Typography } from '@mui/material';
import { sxConfig } from '../Interface/interface.style';
import { ProjectMain } from './ProjectMain';

const ProjectDialog = ({ showDialog, onClose }) => {
  const { setFieldValue } = useFormikContext();
  const [selectedProject, setSelectedProject] = useState(null);

  const handleClose = () => {
    if (onClose) {
      // ha nincs kiválasztott cikk, null-lal hívjuk vissza
      onClose(selectedProject?.projectId ?? null, setFieldValue);
    }
    // lokális állapot reset a következő nyitáshoz
    setSelectedProject(null);
  };

  return (
    <DialogUI
      open={showDialog}
      headerContent={'Projekt'}
      fullWidth={true}
      onClose={handleClose}
      closeBtn={true}
      actionsContent={
        selectedProject?.projectId ? (
          <Box sx={sxConfig.dialogActionContent}>
            <Typography variant="body2" noWrap sx={sxConfig.dialogActionContentTypography1}>
              Választott projekt:
              <Box component="span" sx={sxConfig.dialogActionContentTypography2}>
                {selectedProject?.projectName}
              </Box>
            </Typography>
          </Box>
        ) : null
      }
      maxWidth="xl"
    >
      <ProjectMain fromDialog={true} dialogSetSelectedProject={setSelectedProject} />
    </DialogUI>
  );
};

export default ProjectDialog;
